// SEO.jsx appends " | Fidelis Logic" to every title, so titles here omit the
// brand. Keep each title in step with the matching route in
// backend/seo_prerender.py so crawlers and browsers see the same one.
export const seoConfig = {
  home: {
    title: "UAE IT Consulting & Modern Workplace Solutions",
    description: "Leading UAE IT consulting firm specializing in Microsoft Teams Rooms, Zoom Rooms, enterprise headsets, workspace experience platforms, and business applications. Vendor-neutral guidance for modern workplace technology.",
    keywords: "IT consulting UAE, Fidelis Logic, modern workplace solutions, Microsoft Teams Rooms UAE, Zoom Rooms Dubai, enterprise headsets, workspace experience, ERP implementation UAE"
  },
  solutions: {
    title: "Modern Workplace Technology Solutions",
    description: "Comprehensive IT consulting services for UAE organizations: meeting room technology, collaboration devices, workspace experience platforms, and business applications with vendor-neutral guidance.",
    keywords: "workplace technology solutions, IT consulting services UAE, meeting room solutions, collaboration technology, business applications"
  },
  meetingRooms: {
    title: "Microsoft Teams Rooms & Zoom Rooms Deployment UAE",
    description: "Expert consultation for Microsoft Teams Rooms, Zoom Rooms, and BYOD meeting spaces. Professional AV system design, installation, and commissioning in UAE.",
    keywords: "Microsoft Teams Rooms UAE, Zoom Rooms Dubai, meeting room technology, AV systems, video conferencing, MTR deployment, BYOD meeting rooms"
  },
  headsets: {
    title: "Enterprise Headsets & Collaboration Devices UAE",
    description: "Standardize communication devices across your UAE organization. Expert guidance on enterprise headsets for call centers, hybrid workers, and executives.",
    keywords: "enterprise headsets UAE, collaboration devices, Poly headsets, Jabra headsets, Logitech, call center headsets, UC devices"
  },
  workspaceExperience: {
    title: "Room Booking, Hot Desking & Workspace Experience UAE",
    description: "Optimize office utilization with room booking systems, hot desking, visitor management, and workplace analytics. Flowscape, ROOMZ, and leading platforms.",
    keywords: "room booking system UAE, hot desking Dubai, workspace experience, Flowscape UAE, ROOMZ, visitor management, workplace analytics"
  },
  businessApps: {
    title: "Low Cost ERP Solution, HRMS, CRM & AI ERP Integration UAE",
    description: "Low cost ERP solution, affordable HRMS, CRM, and AI ERP integration for small businesses in the UAE. Near-zero license cost platform options, cloud or on-prem deployment, configuration support, AI-assisted ERP updates, and monthly plans from USD 10/month.",
    keywords: "low cost ERP solution, low cost ERP solution UAE, affordable ERP Dubai, AI ERP integration UAE, ERP AI automation, ERP for small business UAE, HRMS for small business UAE, CRM for small business Dubai, open source ERP UAE, AI business applications UAE, cloud ERP UAE, on premise ERP UAE, small business ERP Dubai"
  },
  about: {
    title: "About Us | Independent Workplace Technology Advisers in the UAE",
    description: "Fidelis Logic LLC is an independent workplace technology adviser with 20+ years of experience, certified project management and technical certifications, working through customers' own resellers and system integrators across the UAE and GCC.",
    keywords: "IT consulting UAE, Fidelis Logic, independent technology adviser UAE, workplace technology experts, technology consultants Dubai"
  },
  blog: {
    title: "Blog | Modern Workplace Technology Insights",
    description: "Expert insights on workplace technology, meeting room solutions, collaboration devices, and business applications. Practical guidance for UAE organizations.",
    keywords: "workplace technology blog, IT consulting insights, meeting room best practices, collaboration technology tips"
  },
  forOrganisations: {
    title: "Independent Workplace Technology Advice for UAE Organisations",
    description:
      "Independent assessment, solution selection and documentation for meeting rooms, workspace management and business applications — delivered with the reseller or system integrator you already use.",
    keywords:
      "independent IT advice UAE, workplace technology consultant UAE, meeting room assessment Dubai, vendor neutral AV consultant, technology procurement support UAE"
  },
  forPartners: {
    title: "White-Label Assessment, Design & Delivery Support for Resellers",
    description:
      "Confidential white-label capacity for UAE and GCC resellers and system integrators: discovery, site assessment, solution design, documentation, project management, deployment assistance, training and support.",
    keywords:
      "white label AV support UAE, reseller design support, system integrator subcontractor UAE, AV project management UAE, white label deployment GCC"
  },
  caseStudies: {
    title: "Case Studies | Workplace Technology Projects",
    description:
      "How organisations and delivery partners in the UAE and GCC reached a workplace technology decision — the situation, the assessment, the recommendation, the delivery model and the verified result.",
    keywords:
      "workplace technology case studies UAE, meeting room project examples, room booking deployment case study, AV project case study Dubai"
  },
  contact: {
    title: "Contact Us | Schedule a Free IT Consultation",
    description: "Book a free consultation to discuss your modern workplace technology needs. Expert guidance for UAE organizations on meeting rooms, collaboration devices, and business applications.",
    keywords: "IT consultation UAE, contact Fidelis Logic, technology consulting Dubai, free consultation"
  }
};
